import { acceptedPaymentMethod } from "../../types/customer.types";

export function isPaymentMethodAccepted(
  cardType: 'CREDIT' | 'DEBIT',
  acceptedMethods: (string | null | undefined)[]
): boolean {
  const methodKey = cardType === 'DEBIT' ? 'debit_card' : 'credit_card';
  return acceptedMethods.includes(methodKey);
}

export function buildPaymentParams(
  cardType: 'CREDIT' | 'DEBIT',
  checkoutData: any,
  installmentsRef: any
): any {
  return cardType === 'DEBIT'
    ? getDebitParam(checkoutData)
    : getCreditParam(checkoutData, installmentsRef);
}

export function getDebitParam(checkoutData: any) {
    return {
        payments: [
          {
            payment_method: 'debit_card' as acceptedPaymentMethod,
            debit_card: {
              payload: {
                type: 'click_to_pay',
                click_to_pay: {
                  card_encrypted_data: checkoutData.paymentPayload,
                }
              }
            },
          },
        ],
      };
  }

  export function getCreditParam(checkoutData: any, installmentsRef: any) {
    return {
        payments: [
          {
            payment_method: 'credit_card' as acceptedPaymentMethod,
            credit_card: {
              installments: installmentsRef.current || 1,
              payload: {
                type: 'click_to_pay',
                click_to_pay: {
                  card_encrypted_data: checkoutData.paymentPayload,
                }
              }
            },
          },
        ],
      };
  }